
<div class="col-md-12"><h3><a href="{{contextPath}}/home">{{{message}}}</a></h3></div>